// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"861":"a03ef4cd","976":"a03ef4cd"}[chunkId] + ".chunk.css";
};